import { render, staticRenderFns } from "./repagesTail.vue?vue&type=template&id=31a794af&scoped=true&"
import script from "./repagesTail.vue?vue&type=script&lang=js&"
export * from "./repagesTail.vue?vue&type=script&lang=js&"
import style0 from "./repagesTail.vue?vue&type=style&index=0&id=31a794af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a794af",
  null
  
)

export default component.exports